import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Typography } from '@mui/material'
import TableSortLabel from '@mui/material/TableSortLabel'
import { useTranslation } from 'react-i18next'
import { FsOFATableHeaderProps, FsOFAValue, OFATableHeadCell } from '../../shared/model/models'
import { useAppSelector } from '../../store/hooks'

const FsOFACareerTableHeader = (props: FsOFATableHeaderProps) => {
  const { order, orderBy, onRequestSort, diversityDimenstionConfig } = props
  const { t } = useTranslation()
  const { currentTheme } = useAppSelector((state) => state.currentUser)

  const createSortHandler =
    (property: keyof Omit<FsOFAValue, 'occupations'>) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property)
    }

  const headCells: OFATableHeadCell[] = [
    {
      id: 'careerLevel',
      label: t('ofa.career.level'),
    },
    {
      id: 'actualGap',
      label: t('ofa.header.cur.gap'),
    },
    {
      id: 'totalEmployeesConcerned',
      label: t('ofa.header.cur.emp'),
    },
    {
      id: 'newGap',
      label: t('ofa.header.new.gap'),
      isNew: true,
    },
    {
      id: 'additionalCmAverage',
      label: t('ofa.header.new.emp'),
      isNew: true,
    },
    {
      id: 'additionalCost',
      label: `${t('ofa.header.add')} ${t('ofa.header.monthly.cost')}`,
      isNew: true,
    },
    {
      id: 'costAsPercentageOfPayroll',
      label: t('ofa.header.pct.cost'),
      isNew: true,
    },
  ]

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell: any) => (
          <TableCell
            key={`header_${headCell.id}`}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order ?? false : false}
            sx={{
              fontWeight: 'semibold',
              backgroundColor: headCell.isNew
                ? diversityDimenstionConfig?.fsColor.colors[currentTheme === 'dark' ? 0 : 3]
                : '',
              py: 1.5,
            }}
          >
            <TableSortLabel
              active={!!order && orderBy === headCell.id}
              direction={orderBy === headCell.id ? order ?? 'asc' : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography>{headCell.label}</Typography>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default FsOFACareerTableHeader
